export default "__VITE_ASSET__NHvOw8At__"